import { render, staticRenderFns } from "./util.vue?vue&type=template&id=3b230a7b&scoped=true&lang=pug&"
import script from "./util.vue?vue&type=script&lang=js&"
export * from "./util.vue?vue&type=script&lang=js&"
import style0 from "./util.vue?vue&type=style&index=0&id=3b230a7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b230a7b",
  null
  
)

/* custom blocks */
import block0 from "~/lang/user?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231207155841%2Fcomponents%2Fsite%2Fnav%2Futil.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports